import store from "../../app/store";
import { rotateToken } from "../../features/auth/authSlice";


export function setupTokenBroadcastSync() {
  const channel = new BroadcastChannel("auth");

  channel.onmessage = (event) => {
    if (event.data?.type === "TOKEN_UPDATED" && event.data.accessToken) {
      store.dispatch(rotateToken({ accessToken: event.data.accessToken }));
    }
  };

  // Optional: return cleanup function
  return () => channel.close();
}
